import { sql } from 'drizzle-orm'
import { text } from 'drizzle-orm/sqlite-core'

export const id = () => text('id').primaryKey()

export const timestamps = {
  createdAt: text('created_at')
    .notNull()
    .default(sql`(strftime('%Y-%m-%dT%H:%M:%fZ','now'))`),
  updatedAt: text('updated_at')
    .notNull()
    .default(sql`(strftime('%Y-%m-%dT%H:%M:%fZ','now'))`),
}
